/**
 * Utility functions for Matomo tracking
 */

/**
 * Track a page view in Matomo
 * @param {string} path - The current path (e.g., '/sales')
 * @param {string} title - The page title (e.g., 'Sales Page')
 */
export const trackPageView = (path, title) => {
  if (window._paq) {
    window._paq.push(['setCustomUrl', path]);
    window._paq.push(['setDocumentTitle', title]);
    window._paq.push(['trackPageView']);
  }
};

/**
 * Track an event in Matomo
 * @param {string} category - Event category (e.g., 'Checkout')
 * @param {string} action - Event action (e.g., 'Click')
 * @param {string} [name] - Optional event name (e.g., 'Buy Button')
 * @param {number} [value] - Optional event value
 */
export const trackEvent = (category, action, name, value) => {
  if (window._paq) {
    if (value !== undefined) {
      window._paq.push(['trackEvent', category, action, name, value]);
    } else if (name !== undefined) {
      window._paq.push(['trackEvent', category, action, name]);
    } else {
      window._paq.push(['trackEvent', category, action]);
    }
  }
};

/**
 * Track an e-commerce order
 * @param {Object} order - Order details
 * @param {string} order.orderId - Unique order identifier
 * @param {number} order.total - Total amount in the original currency
 * @param {number} [order.subTotal] - Sub total amount
 * @param {number} [order.tax] - Tax amount
 * @param {number} [order.shipping] - Shipping amount
 * @param {number} [order.discount] - Discount amount
 */
export const trackOrder = (order) => {
  if (window._paq && order) {
    window._paq.push(['trackEcommerceOrder', 
      order.orderId, 
      order.total, 
      order.subTotal || order.total, 
      order.tax || 0, 
      order.shipping || 0, 
      order.discount || 0
    ]);
  }
}; 